import { AnyAction } from 'redux';

/**
 * The payload to set the current EVA endpoint
 *
 * @export
 * @interface IEndpointActionPayload
 */
export interface IEndpointActionPayload {
  endpoint: string;
}

/**
 * The endpoint action type
 *
 * @export
 * @interface IEndpointAction
 * @extends {AnyAction}
 */
export interface IEndpointAction extends AnyAction {
  type: 'ENDPOINT';
  payload: IEndpointActionPayload;
}

/**
 * Helper method to create a typed EVA Endpoint update message
 *
 * @export
 * @template SVC
 * @param {IEndpointAction} params The response action parameters
 * @returns
 */
export function createEndpointAction(
  params: IEndpointActionPayload,
) {

  // Build the final action object
  //
  const action: IEndpointAction = {
    type: 'ENDPOINT',
    payload: params,
  };

  return action;
}
